import { ItemConfig } from '@/constants'

export function findChild(location: string, config?: ItemConfig[]) {
  return config?.find((entry) =>
    entry.exact
      ? entry.path === location
      : location.substring(0, entry.path.length) === entry.path,
  )
}

export function getItemUrl(config: ItemConfig) {
  return config.href ?? config.path
}
